

import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, DatePicker, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import AppLayout from '../../components/AppLayout';

const { RangePicker } = DatePicker;

const JobCardForm: React.FC = () => {
  const [form] = Form.useForm();
  const [workOrders, setWorkOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/manufacturing/work-orders`)
      .then(res => setWorkOrders(res.data))
      .catch(() => message.error('Failed to load work orders'));
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);
      const [start, end] = values.duration || [];
      await axios.post(`${process.env.REACT_APP_API_URL}/manufacturing/job-cards`, {
        work_order_id: values.work_order_id,
        technician_name: values.technician_name,
        stage: values.stage,
        start_time: start,
        end_time: end
      });
      message.success('Job Card Created');
      form.resetFields();
    } catch {
      message.error('Failed to create job card');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ maxWidth: 600, margin: '2rem auto' }}
      >
        <Form.Item name="work_order_id" label="Work Order" rules={[{ required: true }]}>
          <Select
            placeholder="Select Work Order"
            options={workOrders.map(wo => ({
              label: wo.work_order_no,
              value: wo._id
            }))}
          />
        </Form.Item>

        <Form.Item name="technician_name" label="Technician Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="stage" label="Stage" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="duration" label="Start and End Time" rules={[{ required: true }]}>
          <RangePicker showTime style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Create Job Card
          </Button>
        </Form.Item>
      </Form>
    </AppLayout>
  );
};

export default JobCardForm;